import { useState, useMemo, useCallback } from "react";
import { CsvFileType } from "../../../../molecules/csv-uploader";
import {
  OperationState,
  UpdateProcedureGroupPreviewResponse,
  UpdateProcedureGroupResponse,
} from "../../../../../application/domain/procedures/procedure-update-group";
import { toast } from "react-toastify";

export const useUpdateProcedureGroup = ({
  bulkUpdateGroupPreview,
  bulkUpdateGroup,
  orgId,
}: {
  bulkUpdateGroupPreview: (
    csv: string,
    orgId: string,
  ) => Promise<UpdateProcedureGroupPreviewResponse | string>;
  bulkUpdateGroup: (
    csv: string,
    orgId: string,
  ) => Promise<UpdateProcedureGroupResponse | string>;
  orgId: string;
}) => {
  const [operationStatus, setOperationStatus] =
    useState<OperationState>("DOWNLOAD");
  const [updatePreviewResponse, setUpdatePreviewResponse] =
    useState<UpdateProcedureGroupPreviewResponse>();
  const [updateResponse, setUpdateResponse] =
    useState<UpdateProcedureGroupResponse>();
  const [file, setFile] = useState<CsvFileType | undefined>();

  const isExistValidateError = useMemo(() => {
    const validateErrorCount = updatePreviewResponse?.results.filter(
      (r) => r.validateError?.errCode !== "",
    ).length;

    return validateErrorCount !== 0;
  }, [updatePreviewResponse]);

  const execPreview = useCallback(async () => {
    if (!file) {
      return;
    }

    try {
      const res = await bulkUpdateGroupPreview(file!.data, orgId);
      if (typeof res !== "string" && !!res) {
        setUpdatePreviewResponse(res);
        setOperationStatus("PREVIEW");
      }
    } catch (e) {
      toast.error(e);
    }
  }, [bulkUpdateGroupPreview, file, orgId]);

  const execBulkUpdate = useCallback(async () => {
    if (isExistValidateError) {
      return;
    }

    try {
      const res = await bulkUpdateGroup(file!.data, orgId);
      if (typeof res !== "string" && !!res) {
        setUpdateResponse(res);
        setOperationStatus("RESULT");
        toast.info("グループの更新が完了しました。");
      }
    } catch (e) {
      toast.error(e);
    }
  }, [isExistValidateError, bulkUpdateGroup, file, orgId]);

  return {
    operationStatus,
    setOperationStatus,
    updatePreviewResponse,
    updateResponse,
    file,
    setFile,
    execPreview,
    execBulkUpdate,
    isExistValidateError,
  };
};
